import React from 'react'

import delve from 'dlv'

import { getDataDependencies, buildStaticPaths } from 'services/api'

import fetchContentType from 'src/lib/Strapi/fetchContentType'
import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'

import SliceManager from 'components/shared/SliceManager'
import PreviewBanner from 'components/shared/PreviewBanner'
import BackToList from 'components/shared/BackToList'

const Universals = ({ pageData, preview, integrationSlug }) => {
  const slices = delve(pageData, 'slices')

  return (
    <div className="container">
      <BackToList
        text="Back to integration"
        url={`/integrations/${integrationSlug}`}
      />
      {preview && <PreviewBanner />}
      {slices && <SliceManager slices={slices} />}
    </div>
  )
}

export async function getStaticPaths() {
  // Fetch data that includes both 'slug' and 'topicSlug'
  const integrationTopics = await fetchAllSlugs(
    'integration-topics',
    'populate=integration'
  ) // Replace with your actual fetch function

  const data = [
    ...integrationTopics.map((item) => ({
      ...item,
      specialPath: `topics/${item.slug}`,
    })),
  ]
  return buildStaticPaths(data, 'integrations', {isIntegrations: true})
}

export async function getStaticProps({ preview = null, params }) {
  const data = await fetchContentType(
    'integration-topics',
    `filters[slug][$eq]=${params?.topicSlug}${
      preview ? '&publicationState=preview' : ''
    }`
  )

  if (data?.length === 0 || !data) {
    return {
      props: {},
      notFound: true,
    }
  }

  const pageData = await getDataDependencies(delve(data, '0'))
  return {
    props: {
      pageData,
      preview,
      integrationSlug: params?.slug,
    },
  }
}

export default Universals
